import React from "react";
import classnames from "classnames";

import { ChevronLeft } from "./icons/ChevronLeft";
import { ChevronRight } from "./icons/ChevronRight";

interface MegaSectionButtonProps {
  label: string;
  onClick: () => void;
  active?: boolean;
}

export const MegaSectionButton = (props: MegaSectionButtonProps) => {
  const labelClassName = classnames("text-ash", {
    "txt-body-14": !props.active,
    "txt-body-14sb order-1": props.active,
  });
  const className = classnames("flex items-center py-4 select-none cursor-pointer", {
    "justify-between": !props.active,
    "": props.active,
  });
  return (
    <div className={className} onClick={props.onClick}>
      <div className={labelClassName}>{props.label}</div>
      {!props.active ? <ChevronRight className="w-4 h-4" /> : <ChevronLeft className="w-4 h-4 mr-1" />}
    </div>
  );
};
